<template>
    <div>
        <ConversationIndex :index="index" />
        <v-card-actions class="justify-end">
            <Link :href="route('conversation.show')">
                <v-btn text small rounded color="accent"
                    >Go To Messages</v-btn
                ></Link
            ></v-card-actions
        >
    </div>
</template>

<script>
import axios from "axios";
import ConversationIndex from "../Conversation/ConversationIndex.vue";
import { Link } from "@inertiajs/vue2";

export default {
    components: {
        ConversationIndex,
        Link,
    },
    data() {
        return {
            index: [],
        };
    },
    methods: {
        getMessages() {
            axios
                .get("/conversations")
                .then((resp) => (this.index = resp.data));
        },
    },
    mounted() {
        this.getMessages();
    },
};
</script>
